import { css, type Theme } from "@emotion/react";

export const FeaturedBrandsImage = (theme: Theme) => css`
  width: 8rem;
  height: 3.5rem;
  border: 2px solid ${theme.system.borderBase};
  border-radius: 4px;
  object-fit: contain;
`;

export const FeaturedBrandsGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1rem;
`;
